import { environment } from '../../../environments/environment';

export const BaseUrl = {
    AUTHENTICATE: environment.apiURL + '/airefined-user-api',
    USER: environment.apiURL + '/airefined-user-api',
    AUTHORIZATION: environment.apiURL + '/airefined-authorization-api',
    ASSESSMENT: environment.apiURL +'/airefined-community-assessment-api',
    Document: environment.apiURL + '/airefined-document-api',
    LOGO: environment.logo,
    APPTITLE: environment.appTitle,
};
